import { useCallback } from 'react';

import useValueFormatters from 'hooks/useValueFormatters';

const useFormatPaymentAmount = () => {
  const { formatValue } = useValueFormatters();

  return useCallback(
    (amount: number) =>
      formatValue({
        value: amount,
        formatting: { prefix: 'currency', precision: 2, currencyType: 'USD' },
      }),
    [formatValue],
  );
};

export default useFormatPaymentAmount;
